
import { v4 } from 'uuid';
import { defineComponent } from 'vue';

export default defineComponent({
    name: "SearchWImage",
    data() {
      return {
        id: v4(),
      };
    },
    methods: {
      bgClick(e:MouseEvent | TouchEvent) {
        if (e.target !== this.$refs[this.id]) return;
        this.$emit('onExit');
      },
      handleInput(e: Event) {
        this.$emit('onInputChange', e);
      }
    },
    beforeUpdate() {
      this.$slots.items;
    },
    emits: ['onExit', 'onInputChange']
})
